import { IDecideNextStep } from "../../services/wizard/next-step-decider/next-step-decider.interface";
import { TcpaConsentStepComponent } from "../../wizard/wizard-steps/tcpa-consent-step/tcpa-consent-step.component";
import { WizardStepBase } from "./wizard-step-base.model";

export class TcpaConsentStep extends WizardStepBase {
  constructor(id: string, name: string, path: string, nextStepDecider?: IDecideNextStep) {
    super(id, name, path, nextStepDecider);
    this.component = TcpaConsentStepComponent;
  }
}
